import React from "react";

import IconGrid from "icons/IconGrid";
import SearchAndBrowseIconGridWithAds from "./SearchAndBrowseIconGridWithAds";

import breakpoints from "core/breakpoints";

import { convertPxToRem } from "frontend/components/helpers";
import { useCurrentUser } from "js/contexts/CurrentUserContext";
import { useViewport } from "js/hooks/useViewport";

const SearchAndBrowseIconGrid = ({ iconData }) => {
    const { browserWidth } = useViewport();
    const onDesktop = browserWidth >= breakpoints.desktop.px;
    const onTablet =
        browserWidth < breakpoints.desktop.px &&
        browserWidth >= breakpoints.tablet.px;
    const onMobile = browserWidth < breakpoints.tablet.px;

    const user = useCurrentUser();
    const userHasSubscription = user && user.hasSubscription;
    const Grid = userHasSubscription
        ? IconGrid
        : SearchAndBrowseIconGridWithAds;

    let numberOfColumns;
    let gridSpacingSize;

    if (onDesktop) {
        numberOfColumns = 5;
        gridSpacingSize = convertPxToRem({ px: 24 });
    }

    if (onTablet) {
        numberOfColumns = 4;
        gridSpacingSize = convertPxToRem({ px: 24 });
    }

    if (onMobile) {
        numberOfColumns = 2;
        gridSpacingSize = convertPxToRem({ px: 16 });
    }

    return (
        <Grid
            iconData={iconData}
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
        />
    );
};

export default SearchAndBrowseIconGrid;
